"use client";

import BriefingFormShell from "@app/toolkit/_shared/components/BriefingFormShell";
import type { BriefingFormProps } from "@app/toolkit/_shared/types";
import PotentialPanel from "./potential/PotentialPanel";
import { usePotential } from "./potential/usePotential";
import { POTENTIAL_CONFIG } from "../config";
import type { PotentialFocus } from "../types";

/**
 * Binds the shared form shell to this page's side panel: the live potential
 * derived from the answers. Text only, so no fullscreen modal is needed.
 */
export default function BriefingForm(props: BriefingFormProps<PotentialFocus>) {
  const potential = usePotential(props.data.sections, props.answers);
  const { sidePanel } = props.data;

  const header = (compact: boolean) => (
    <p
      className={
        compact
          ? "text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2.5 flex items-center justify-between gap-2"
          : "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 flex items-center justify-between gap-2"
      }
    >
      <span>{sidePanel.title}</span>
      <span className="text-gray-400 font-normal normal-case truncate max-w-[55%] text-right">
        {potential.title}
      </span>
    </p>
  );

  return (
    <BriefingFormShell
      {...props}
      config={POTENTIAL_CONFIG}
      aside={{
        renderMobile: (focus) => (
          <div className="block lg:hidden mb-5 rounded-xl border border-gray-200 bg-white p-3.5">
            {header(true)}
            <PotentialPanel potential={potential} focus={focus} />
          </div>
        ),
        renderDesktop: (focus) => (
          <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm max-h-[calc(100dvh-13rem)] overflow-y-auto">
            {header(false)}
            <PotentialPanel potential={potential} focus={focus} />
            <p className="text-[11px] text-gray-400 mt-3 leading-snug">{sidePanel.caption}</p>
          </div>
        ),
      }}
    />
  );
}
